const DEFAULT_TOMBSTONE_INTERMEDIARY = 'StartEngine Primary, LLC';

export const TOMBSTONE_LEGAL_ENTITY_FLAG = 'non-bd-tombstone-legal-entity';

interface TombstoneIntermediaryFields {
  slug?: string | null;
  key?: string | null;
  seBrokerDealer?: boolean | null;
  companyLegalName?: string | null;
}

export const tombstoneIntermediary = (
  { slug, key, seBrokerDealer, companyLegalName }: TombstoneIntermediaryFields,
  useCompanyLegalName = false,
): string => {
  if (useCompanyLegalName && seBrokerDealer === false) {
    return companyLegalName?.trim() || DEFAULT_TOMBSTONE_INTERMEDIARY;
  }

  const offeringSlug = slug ?? key;
  if (!useCompanyLegalName && offeringSlug?.trim().toLowerCase() === 'startengine') {
    return 'StartEngine, Inc.';
  }

  return DEFAULT_TOMBSTONE_INTERMEDIARY;
};
